
import "../Foundation/stylable/colors.st.css.js";
import "../common/Focusable/Focusable.st.css.js";
import "../Text/Text.st.css.js";

import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_178_0_Radio";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_178_0_Radio__root","input":"wds_1_178_0_Radio__input","icon":"wds_1_178_0_Radio__icon","label":"wds_1_178_0_Radio__label","labelText":"wds_1_178_0_Radio__labelText"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-radio-label-font-line-height-medium":"--wds-radio-label-font-line-height-medium","wds-radio-label-font-line-height-small":"--wds-radio-label-font-line-height-small","wds-radio-label-font-size-medium":"--wds-radio-label-font-size-medium","wds-radio-label-font-size-small":"--wds-radio-label-font-size-small","wds-radio-border":"--wds-radio-border","wds-radio-border-active":"--wds-radio-border-active","wds-radio-border-active-disabled":"--wds-radio-border-active-disabled","wds-radio-border-disabled":"--wds-radio-border-disabled","wds-radio-border-hover":"--wds-radio-border-hover","wds-radio-border-radius":"--wds-radio-border-radius","wds-radio-fill":"--wds-radio-fill","wds-radio-fill-active":"--wds-radio-fill-active","wds-radio-fill-active-hover":"--wds-radio-fill-active-hover","wds-radio-fill-active-disabled":"--wds-radio-fill-active-disabled","wds-radio-fill-disabled":"--wds-radio-fill-disabled","wds-radio-fill-hover":"--wds-radio-fill-hover","wds-radio-dot-fill-active":"--wds-radio-dot-fill-active","wds-radio-dot-fill-disabled":"--wds-radio-dot-fill-disabled","wds-radio-dot-size":"--wds-radio-dot-size","wds-shadow-focus-standard":"--wds-shadow-focus-standard","wds-space-200":"--wds-space-200"}; 




